import type { IconData } from '@stacksjs/iconify-core'

export const basicArrowsLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8 0L0 8l8 8v-4h8V4H8z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicArrowsLeft
